@if (combinedPnLs().length > 0) {
  <div class="pnl-container">
    <table>
      @if (isAsianHandicap) {
        <thead>
          <tr>
            <th></th>
            @for (each of combinedPnLs(); track each?.label; let i = $index) {
              <th [ngClass]="{ 'bg-th': each?.label !== 'Draw' }" class="bg-th" [colSpan]="each?.label === 'Draw' ? 1 : combinedPnLs()?.[i]?.pnls?.length">
                {{ each?.label !== "Draw" ? each?.label : "" }}
              </th>
            }
          </tr>
        </thead>
      }
      <tbody>
        <tr>
          <td>
            <b>P&L by Outcome</b>
          </td>
          @for (each of combinedPnLs(); track each?.label) {
            @for (every of each?.pnls; track every?.goals) {
              @let goals = every?.goals;
              @let areMultiple = goals?.length;
              <td>
                @if (areMultiple) {
                  @let firstGoal = goals?.[0];
                  @let lastGoal = goals?.[goals?.length - 1];
                  @if (isAsianHandicap) {
                    @if (firstGoal === hcpRanges.pnlLength) {
                      <span>{{ lastGoal }}+</span>
                    } @else if (lastGoal === hcpRanges.pnlLength) {
                      <span>{{ firstGoal }}+</span>
                    } @else {
                      <span>{{ firstGoal }} - {{ lastGoal }}</span>
                    }
                  } @else {
                    @if (lastGoal === hcpRanges.max) {
                      <span>{{ firstGoal }}+</span>
                    } @else {
                      <span>{{ firstGoal }} - {{ lastGoal }}</span>
                    }
                  }
                } @else {
                  @if (isAsianHandicap) {
                    <span>
                      @if (goals === 0) {
                        Draw
                      } @else if (goals === hcpRanges.pnlLength) {
                        {{ hcpRanges.pnlLength }}+
                      } @else {
                        {{ goals }}
                      }
                    </span>
                  } @else {
                    <span> {{ goals }}{{ goals === hcpRanges.max ? "+" : "" }} </span>
                  }
                }
              </td>
            }
          }
        </tr>
        <tr>
          <td>
            <b>Current P&L</b>
          </td>
          @for (each of combinedPnLs(); track each?.label) {
            @for (every of each?.pnls; track every?.goals) {
              @let pnl = every?.pnl;
              <td>
                <b
                  [ngClass]="{
                    'pnl-red': pnl < 0,
                    'pnl-green': pnl >= 0,
                  }"
                  >{{ pnl | number: "1.2-2" }}</b
                >
              </td>
            }
          }
        </tr>
      </tbody>
    </table>
  </div>
}
